import React, { useState, useEffect } from 'react';

const Produk = () => {
  const [produk, setProduk] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('semua');

  useEffect(() => {
    // Simulasi fetch data dari API
    setTimeout(() => {
      setProduk([
        {
          id: 1,
          nama: 'Keripik Singkong',
          harga: 15000,
          deskripsi: 'Keripik singkong renyah dengan berbagai varian rasa',
          gambar: '/images/keripik-singkong.jpg',
          kategori: 'Makanan',
          stok: 50,
          rating: 4.5,
          terjual: 120
        },
        {
          id: 2,
          nama: 'Madu Hutan',
          harga: 75000,
          deskripsi: 'Madu hutan asli dari desa kami',
          gambar: '/images/madu-hutan.jpg',
          kategori: 'Minuman',
          stok: 25,
          rating: 4.8,
          terjual: 85
        },
        {
          id: 3,
          nama: 'Kerajinan Anyaman',
          harga: 45000,
          deskripsi: 'Kerajinan anyaman tangan dari bambu',
          gambar: '/images/anyaman.jpg',
          kategori: 'Kerajinan',
          stok: 30,
          rating: 4.3,
          terjual: 65
        },
        {
          id: 4,
          nama: 'Kopi Arabika',
          harga: 35000,
          deskripsi: 'Kopi arabika khas desa dengan cita rasa premium',
          gambar: '/images/kopi.jpg',
          kategori: 'Minuman',
          stok: 40,
          rating: 4.7,
          terjual: 95
        }
      ]);
      setLoading(false);
    }, 1000);
  }, []);

  const filteredProduk = filter === 'semua' 
    ? produk 
    : produk.filter(item => item.kategori === filter);

  const kategori = ['semua', ...new Set(produk.map(item => item.kategori))];

  const formatRupiah = (amount) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0
    }).format(amount);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Manajemen Produk</h1>
          <p className="text-gray-600">Kelola produk UMKM BUMDES</p>
        </div>
        <button className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center">
          <span className="mr-2">+</span> Tambah Produk
        </button>
      </div>

      {/* Filter dan Stats */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
          <div className="flex flex-wrap gap-2">
            {kategori.map((kat) => (
              <button
                key={kat}
                onClick={() => setFilter(kat)}
                className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                  filter === kat
                    ? 'bg-blue-500 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {kat.charAt(0).toUpperCase() + kat.slice(1)}
              </button>
            ))}
          </div>
          <div className="text-sm text-gray-600">
            Menampilkan {filteredProduk.length} dari {produk.length} produk
          </div>
        </div>
      </div>

      {/* Produk Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {filteredProduk.map((item) => (
          <div key={item.id} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden hover:shadow-md transition-shadow group">
            <div className="h-48 bg-gradient-to-br from-blue-100 to-green-100 flex items-center justify-center relative overflow-hidden">
              <div className="text-5xl text-gray-400 group-hover:scale-110 transition-transform duration-300">
                {item.kategori === 'Makanan' ? '🍪' : 
                 item.kategori === 'Minuman' ? '🍯' : '🧺'}
              </div>
              <div className="absolute top-4 right-4 bg-white rounded-full px-3 py-1 shadow-sm">
                <span className="text-yellow-500 text-sm font-semibold">⭐ {item.rating}</span>
              </div>
              <div className="absolute top-4 left-4 bg-white rounded-full px-3 py-1 shadow-sm">
                <span className="text-blue-500 text-sm font-semibold">{item.stok} stok</span>
              </div>
            </div>
            
            <div className="p-5">
              <div className="flex justify-between items-start mb-3">
                <h3 className="font-bold text-gray-900 text-lg leading-tight">{item.nama}</h3>
                <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs font-medium">
                  {item.kategori}
                </span>
              </div>
              
              <p className="text-gray-600 text-sm mb-4 line-clamp-2">{item.deskripsi}</p>
              
              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <span className="text-xl font-bold text-green-600">
                    {formatRupiah(item.harga)}
                  </span>
                  <div className="flex items-center text-sm text-gray-500">
                    <span>🛒 {item.terjual} terjual</span>
                  </div>
                </div>
                
                <div className="flex space-x-2">
                  <button className="flex-1 bg-blue-500 hover:bg-blue-600 text-white py-2 px-3 rounded-lg text-sm font-medium transition-colors flex items-center justify-center">
                    <span className="mr-1">✏️</span> Edit
                  </button>
                  <button className="flex-1 bg-red-500 hover:bg-red-600 text-white py-2 px-3 rounded-lg text-sm font-medium transition-colors flex items-center justify-center">
                    <span className="mr-1">🗑️</span> Hapus
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {filteredProduk.length === 0 && (
        <div className="text-center py-12 bg-white rounded-xl shadow-sm border border-gray-200">
          <div className="text-6xl mb-4">📦</div>
          <h3 className="text-2xl font-semibold text-gray-900 mb-2">Tidak ada produk</h3>
          <p className="text-gray-600 mb-6">Tidak ada produk dalam kategori ini.</p>
          <button className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-lg font-medium transition-colors">
            + Tambah Produk Pertama
          </button>
        </div>
      )}
    </div>
  );
};

export default Produk;